import axios, { AxiosResponse } from 'axios';

import config from '@/config';
import store from '@/store';
import { IdResponse } from '@/api/common';
import FileUpload from '@/api/file-upload';

export default class Media {
  public static async createImage(
    file: File,
    parentModel: string,
    parentId: number,
    fieldName: string
  ) {
    return Media.upload(
      config.API_ROOT + '/media-image/',
      file,
      parentModel,
      parentId,
      fieldName
    );
  }

  public static async createAudio(
    file: File,
    parentModel: string,
    parentId: number,
    fieldName: string
  ) {
    return Media.upload(
      config.API_ROOT + '/media-audio/',
      file,
      parentModel,
      parentId,
      fieldName
    );
  }

  public static async downloadFromUrl(url: string) {
    const response: AxiosResponse = await axios({
      method: 'GET',
      url: config.API_ROOT + `/media/?media_url=${url}`,
      headers: {
        'X-Session': store.state.sessionToken
      }
    });

    return response;
  }

  private static async upload(
    baseUrl: string,
    file: File,
    parentModel: string,
    parentId: number,
    fieldName: string
  ): Promise<number> {
    if (!store.state.sessionToken) {
      throw new Error('Not logged in.');
    }

    const result: string | ArrayBuffer = await this.convertTobase64(file);
    const fileHandle = await FileUpload.upload(file);

    const response: AxiosResponse<IdResponse> = await axios({
      method: 'POST',
      url: baseUrl,
      data: {
        path: fileHandle,
        parent_model: parentModel,
        parent_id: parentId,
        field_name: fieldName,
        file: result
      },
      headers: {
        'X-Session': store.state.sessionToken
      }
    });

    if (!('id' in response.data) || response.data.id === undefined) {
      throw new Error('Missing id in response.');
    }

    return response.data.id;
  }

  public static async deleteImage(id: number) {
    return Media.delete(config.API_ROOT + '/media-image/', id);
  }

  public static async deleteAudio(id: number) {
    return Media.delete(config.API_ROOT + '/media-audio/', id);
  }

  public static async convertTobase64(file: File) {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    return reader.result;
  }

  private static async delete(baseUrl: string, imageId: number) {
    if (!store.state.sessionToken) {
      throw new Error('Not logged in.');
    }

    await axios({
      method: 'DELETE',
      url: `${baseUrl}${imageId}`,
      headers: {
        'X-Session': store.state.sessionToken
      }
    });
  }
}
